import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiddenProps } from './types';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import Button from '../../Button';

import hiddenStyles from './Hidden.scss';

const DeviationBlockedOverlay: React.FC<HiddenProps> = ({
  deviation: { deviationId, author },
  deviation,
  blockDeviant,
  unhideDeviation,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <HiddenLayout
      deviation={deviation}
      icon={<Hidden />}
      title={t('deviationview.blocked.deviation')}
      text={
        <>
          {t('deviationview.blocked.deviation.text')}
          <br />
          {t('deviationview.blocked.deviation.text2')}
        </>
      }
      button={
        <Button
          view="b14"
          height="medium"
          onClick={() => author && blockDeviant(author, deviationId)}
        >
          {t('deviationview.blocked.blockDeviant')}
        </Button>
      }
      secondaryButton={
        author && (
          <button
            className={hiddenStyles['secondary-button']}
            onClick={() => unhideDeviation(deviationId)}
          >
            {t('deviationview.blocked.unhideDeviation')}
          </button>
        )
      }
      {...props}
    />
  );
};
DeviationBlockedOverlay.displayName = 'DeviationBlockedOverlay';

export default DeviationBlockedOverlay;
